/* assets/truerim-motion.js (moved out of sections/truerim-motion.liquid 2026-10-22 so the browser caches it across the color pages). */

(function () {
  var cfg = document.querySelector('[data-trm-config]');
  if (!cfg || document.documentElement.getAttribute('data-trm-ready')) return;
  document.documentElement.setAttribute('data-trm-ready', '1');
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wantReveal = cfg.getAttribute('data-reveal') !== 'false' && !still && 'IntersectionObserver' in window;
  var wantGlow = cfg.getAttribute('data-glow') !== 'false';
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  /* ---------- reveal ---------- */
  var io = null, seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function show(el) {
    el.classList.add('trm-in');
    /* after the transition, freeze the final state (no transform left on the kit's ancestors) */
    setTimeout(function () { el.classList.add('trm-done'); }, 1400);
  }
  function tag(el, variant, delay) {
    if (!el || (seen && seen.has(el)) || el.classList.contains('trm-r')) return;
    if (seen) seen.add(el);
    el.classList.add('trm-r');
    if (variant && variant !== 'up') variant.split(' ').forEach(function (v) { el.classList.add('trm-' + v); });
    if (delay) el.style.setProperty('--trm-d', delay + 's');
    io.observe(el);
  }
  function scan(scope) {
    if (!io) return;
    scope = scope || document;
    /* explicit hooks in section markup: data-trm="up|left|right|scale|blur", data-trm-stagger on a list */
    [].forEach.call(scope.querySelectorAll('[data-trm]:not([data-trm=""])'), function (el) {
      if (el === cfg) return;
      tag(el, el.getAttribute('data-trm'), parseFloat(el.getAttribute('data-trm-delay')) || 0);
    });
    [].forEach.call(scope.querySelectorAll('[data-trm-stagger]'), function (list) {
      var step = parseFloat(list.getAttribute('data-trm-stagger')) || 0.06;
      [].forEach.call(list.children, function (c, i) { tag(c, list.getAttribute('data-trm-child') || 'up', Math.min(i, 8) * step); });
    });
    /* sections we can't edit or whose markup is rendered elsewhere */
    var hero = ['.trpd-vendor', '.trpd-title', '.trpd-stock', '.trpd-price'];
    hero.forEach(function (s, i) { tag(scope.querySelector('.trpd ' + s), 'up', 0.1 + i * 0.12); });
    tag(scope.querySelector('.trpd-stage'), 'scale', 0.2);
    tag(scope.querySelector('.trpd-thumbs'), 'up', 0.35);
    tag(scope.querySelector('.trcp-head'), 'up', 0.15);
    tag(scope.querySelector('[data-trkb-root]'), 'up', 0.2);
    tag(scope.querySelector('.trcp-body'), 'up', 0);
    /* the carousels fade up as one row: per-card reveals would leave side cards hidden until swiped into view */
    tag(scope.querySelector('.trrc-h'), 'up', 0);
    tag(scope.querySelector('.trrc .tr-arc'), 'up', 0.12);
    tag(scope.querySelector('.trcj-h'), 'up', 0);
    tag(scope.querySelector('.trcj-lede'), 'up', 0.08);
    tag(scope.querySelector('.trcj .tr-arc'), 'up', 0.16);
  }
  if (wantReveal) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); show(en.target); } });
    }, { rootMargin: '0px', threshold: 0 });   /* 2026-10-22: shown as soon as any part is on screen (was -80px / 1%: the last blocks of a page could stay hidden) */
    document.documentElement.classList.add('trm-js');
  }

  /* ---------- kit builder: replay the step entrance, pulse the total when it changes ---------- */
  function watchKit() {
    var kit = document.querySelector('[data-trkb-root]');
    if (!kit || kit.getAttribute('data-trm-watch') || !('MutationObserver' in window)) return;
    kit.setAttribute('data-trm-watch', '1');
    var lastTotal = null, lastHead = null, queued = false;
    var tick = function () {
      queued = false;
      var t = kit.querySelector('.trkb-total-v'), h = kit.querySelector('.trkb-body .trkb-h'), b = kit.querySelector('.trkb-body');
      var tv = t ? t.textContent : null, hv = h ? h.textContent : null;
      if (!still && t && lastTotal !== null && tv !== lastTotal) {
        t.classList.remove('trm-flash'); void t.offsetWidth; t.classList.add('trm-flash');
      }
      if (!still && b && lastHead !== null && hv !== lastHead) {
        b.classList.remove('trm-step'); void b.offsetWidth; b.classList.add('trm-step');
      }
      lastTotal = tv; lastHead = hv;
    };
    new MutationObserver(function () { if (!queued) { queued = true; setTimeout(tick, 16); } })
      .observe(kit, { childList: true, subtree: true, characterData: true });
    tick();
  }

  /* ---------- glow: a fixed layer whose two soft lights trail the scroll ---------- */
  function glow() {
    if (!wantGlow || !document.body) return;
    var g = document.createElement('div');
    g.className = 'trm-glow';
    g.setAttribute('aria-hidden', 'true');
    g.innerHTML = '<i class="trm-g2"></i><i class="trm-g1"></i>';
    document.body.insertBefore(g, document.body.firstChild);
    var a = g.querySelector('.trm-g1'), b = g.querySelector('.trm-g2');
    var end = function () {
      var last = document.querySelector('.trcg') || document.querySelector('.trpd');
      return last ? last.getBoundingClientRect().bottom + window.pageYOffset : Infinity;
    };
    var cur = { ax: 0, ay: 0, bx: 0, by: 0, o: 1 }, vel = 0, lastY = window.pageYOffset, running = false, stopAt = 0;
    var target = function () {
      var w = window.innerWidth, h = window.innerHeight, y = window.pageYOffset;
      /* the red light swings side to side as the page scrolls (one swing per screen and a half), the cool light
         opposite it; both sit a little lower while the shopper is moving */
      var s = Math.sin(y / (h * 1.5) * Math.PI);
      var lift = Math.min(vel, 40) / 40;
      return {
        ax: w * (0.5 + 0.42 * s), ay: h * (0.22 + 0.18 * lift + 0.1 * Math.cos(y / h)),
        bx: w * (0.5 - 0.45 * s), by: h * (0.85 - 0.1 * lift),
        o: y + h * 0.4 > end() ? 0 : 1
      };
    };
    var frame = function () {
      var y = window.pageYOffset;
      vel = vel * 0.9 + Math.abs(y - lastY) * 0.1; lastY = y;
      var t = target(), k = still ? 1 : 0.07;
      cur.ax += (t.ax - cur.ax) * k; cur.ay += (t.ay - cur.ay) * k;
      cur.bx += (t.bx - cur.bx) * k; cur.by += (t.by - cur.by) * k;
      cur.o += (t.o - cur.o) * (still ? 1 : 0.06);
      a.style.transform = 'translate3d(' + cur.ax.toFixed(1) + 'px,' + cur.ay.toFixed(1) + 'px,0)';
      b.style.transform = 'translate3d(' + cur.bx.toFixed(1) + 'px,' + cur.by.toFixed(1) + 'px,0)';
      g.style.opacity = g.classList.contains('is-on') ? cur.o.toFixed(3) : '';
      var moving = Math.abs(t.ax - cur.ax) + Math.abs(t.ay - cur.ay) + Math.abs(t.o - cur.o) * 100 > 0.5 || vel > 0.2;
      if (moving || Date.now() < stopAt) raf(frame); else running = false;
    };
    var kick = function () { stopAt = Date.now() + 300; if (!running) { running = true; raf(frame); } };
    var t0 = target(); cur.ax = t0.ax; cur.ay = t0.ay; cur.bx = t0.bx; cur.by = t0.by;
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick, { passive: true });
    kick();
    setTimeout(function () { g.classList.add('is-on'); }, 60);
  }

  function boot() {
    try { scan(document); } catch (e) { document.documentElement.classList.remove('trm-js'); }
    try { watchKit(); } catch (e) {}
    try { glow(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* the kit and the color profile mount in their own scripts: pick them up once the page has loaded */
  window.addEventListener('load', function () {
    try { scan(document); watchKit(); } catch (e) {}
    /* safety net: anything still waiting after 4 s that is already above the fold is shown */
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('.trm-r:not(.trm-in)'), function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) show(el);
      });
    }, 4000);
  });
})();
